import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';

import { DialogCloseButton } from '../DialogCloseButton/DialogCloseButton';

type Props = {
  closeButtonAriaLabel?: string;
  title: string;
  onClose: () => void;
};

export const DialogHeader = ({ closeButtonAriaLabel, onClose, title }: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'space-between',
        pb: 2,
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogCloseButton ariaLabel={closeButtonAriaLabel} onClick={onClose} />
    </Box>
  );
};

DialogHeader.displayName = 'DialogHeader';
